import { c as _c } from "react/compiler-runtime";
import { usePageView } from '@/analytics/pageTypes';
import { SeoPageLayout } from '@/components/layout/SeoPageLayout';
import { Link } from '@/components/links';
import { Button } from '@/components/buttons';
import { FAQs, Hint, Paragraph, SemiBold, SubHeader, Table } from '@/components/seo';
import { LINKS } from '@/constants/links';
import { isAllowedRoute } from '@/lang/pagesConfig';
import { NumericRange } from '@/types/range';
import { getIntlProps, type IntlProps } from '@/utils/intl';
import type { GetStaticProps } from 'next';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { getAllPageMenuPromoBanners, PageMenuPromoBanner } from '@/api/sanity/pageMenuPromoBanner';
interface Props extends IntlProps {
  menuPromoBanners?: PageMenuPromoBanner[];
}
export default function Page(t0) {
  const $ = _c(309);
  const {
    menuPromoBanners
  } = t0;
  usePageView("seo-buy-on-installments");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["seoBuyOnInstallments", "core"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  let t2;
  if ($[1] !== t) {
    t2 = Array.from({
      length: 5
    }, (_, index) => {
      const faqIndex = index + 1 as NumericRange<1, 5>;
      return {
        question: t(`seoBuyOnInstallments:sections.faqs.${faqIndex}.question`),
        answer: t(`seoBuyOnInstallments:sections.faqs.${faqIndex}.answer`)
      };
    });
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const faqsData = t2;
  let t3;
  if ($[3] !== t) {
    t3 = t("seoBuyOnInstallments:seo.title");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t("seoBuyOnInstallments:seo.description");
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = {
      title: t3,
      description: t4
    };
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <br />;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  let t8;
  if ($[11] !== t) {
    t7 = <Trans t={t} i18nKey="seoBuyOnInstallments:header.title">{t6}</Trans>;
    t8 = t("seoBuyOnInstallments:header.intro");
    $[11] = t;
    $[12] = t7;
    $[13] = t8;
  } else {
    t7 = $[12];
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t8) {
    t9 = <p>{t8}</p>;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t) {
    t10 = t("seoBuyOnInstallments:header.button");
    $[16] = t;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = LINKS();
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t10) {
    t12 = {
      label: t10,
      to: t11.installments
    };
    $[19] = t10;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t) {
    t13 = t("seoBuyOnInstallments:sections.1.title");
    $[21] = t;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  let t15;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Paragraph />;
    t15 = <SemiBold />;
    $[23] = t14;
    $[24] = t15;
  } else {
    t14 = $[23];
    t15 = $[24];
  }
  let t16;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = {
      paragraph: t14,
      semibold: t15,
      link1: <Link analyticsParam="linkInstallments" testId="linkInstallments" to={LINKS().installments} />
    };
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== t) {
    t17 = <Trans t={t} i18nKey="seoBuyOnInstallments:sections.1.content" components={t16} />;
    $[26] = t;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  let t18;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = [...Array(6)];
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  let t19;
  if ($[29] !== t) {
    t19 = t18.map((__0, i) => {
      const transIndex = i + 1 as NumericRange<1, 6>;
      return <Trans key={i} t={t} i18nKey={`seoBuyOnInstallments:sections.1.subsections.${transIndex}`} components={{
        subheader: <SubHeader />,
        paragraph: <Paragraph />,
        link1: <Link analyticsParam="linkInstallments" testId="linkInstallments" to={LINKS().installments} />,
        link2: <Link analyticsParam="linkPayInThree" testId="linkPayInThree" to={LINKS().payInThree} />,
        button1: <Button analyticsParam="linkInstallments" testId="linkInstallments" to={LINKS().installments} variant="primary" />
      }} />;
    });
    $[29] = t;
    $[30] = t19;
  } else {
    t19 = $[30];
  }
  let t20;
  if ($[31] !== t17 || $[32] !== t19) {
    t20 = <>{t17}{t19}</>;
    $[31] = t17;
    $[32] = t19;
    $[33] = t20;
  } else {
    t20 = $[33];
  }
  let t21;
  if ($[34] !== t13 || $[35] !== t20) {
    t21 = {
      title: t13,
      content: t20
    };
    $[34] = t13;
    $[35] = t20;
    $[36] = t21;
  } else {
    t21 = $[36];
  }
  let t22;
  if ($[37] !== t) {
    t22 = t("seoBuyOnInstallments:sections.2.title");
    $[37] = t;
    $[38] = t22;
  } else {
    t22 = $[38];
  }
  let t23;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = {
      paragraph: <Paragraph />,
      semibold: <SemiBold />,
      link1: <Link analyticsParam="linkRpsn" testId="linkRpsn" to="https://cs.wikipedia.org/wiki/RPSN" target="_blank" />
    };
    $[39] = t23;
  } else {
    t23 = $[39];
  }
  let t24;
  if ($[40] !== t) {
    t24 = <Trans t={t} i18nKey="seoBuyOnInstallments:sections.2.content" components={t23} />;
    $[40] = t;
    $[41] = t24;
  } else {
    t24 = $[41];
  }
  let t25;
  if ($[42] !== t22 || $[43] !== t24) {
    t25 = {
      title: t22,
      content: t24
    };
    $[42] = t22;
    $[43] = t24;
    $[44] = t25;
  } else {
    t25 = $[44];
  }
  let t26;
  if ($[45] !== t) {
    t26 = t("seoBuyOnInstallments:sections.3.title");
    $[45] = t;
    $[46] = t26;
  } else {
    t26 = $[46];
  }
  let t27;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = {
      paragraph: <Paragraph />,
      semibold: <SemiBold />
    };
    $[47] = t27;
  } else {
    t27 = $[47];
  }
  let t28;
  if ($[48] !== t) {
    t28 = <Trans t={t} i18nKey="seoBuyOnInstallments:sections.3.content" components={t27} />;
    $[48] = t;
    $[49] = t28;
  } else {
    t28 = $[49];
  }
  let t29;
  if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = [...Array(3)];
    $[50] = t29;
  } else {
    t29 = $[50];
  }
  let t30;
  if ($[51] !== t) {
    t30 = t29.map((__1, i_0) => {
      const transIndex_0 = i_0 + 1 as NumericRange<1, 3>;
      return <Trans key={i_0} t={t} i18nKey={`seoBuyOnInstallments:sections.3.subsections.${transIndex_0}`} components={{
        subheader: <SubHeader />,
        paragraph: <Paragraph />,
        link1: <Link analyticsParam="linkPayInThree" testId="linkPayInThree" to={LINKS().payInThree} />
      }} />;
    });
    $[51] = t;
    $[52] = t30;
  } else {
    t30 = $[52];
  }
  let t31;
  if ($[53] !== t28 || $[54] !== t30) {
    t31 = <>{t28}{t30}</>;
    $[53] = t28;
    $[54] = t30;
    $[55] = t31;
  } else {
    t31 = $[55];
  }
  let t32;
  if ($[56] !== t26 || $[57] !== t31) {
    t32 = {
      title: t26,
      content: t31
    };
    $[56] = t26;
    $[57] = t31;
    $[58] = t32;
  } else {
    t32 = $[58];
  }
  let t33;
  if ($[59] !== t) {
    t33 = t("seoBuyOnInstallments:sections.4.title");
    $[59] = t;
    $[60] = t33;
  } else {
    t33 = $[60];
  }
  let t34;
  if ($[61] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = {
      paragraph: <Paragraph />,
      semibold: <SemiBold />
    };
    $[61] = t34;
  } else {
    t34 = $[61];
  }
  let t35;
  if ($[62] !== t) {
    t35 = <Trans t={t} i18nKey="seoBuyOnInstallments:sections.4.content" components={t34} />;
    $[62] = t;
    $[63] = t35;
  } else {
    t35 = $[63];
  }
  let t36;
  if ($[64] === Symbol.for("react.memo_cache_sentinel")) {
    t36 = {
      link1: <Link analyticsParam="linkSeoDeferredPayment" testId="linkSeoDeferredPayment" to={LINKS().aboutDeferredPayment} />
    };
    $[64] = t36;
  } else {
    t36 = $[64];
  }
  let t37;
  if ($[65] !== t) {
    t37 = <Hint text={<Trans t={t} i18nKey="seoBuyOnInstallments:sections.4.hint" components={t36} />} />;
    $[65] = t;
    $[66] = t37;
  } else {
    t37 = $[66];
  }
  let t38;
  if ($[67] !== t35 || $[68] !== t37) {
    t38 = <>{t35}{t37}</>;
    $[67] = t35;
    $[68] = t37;
    $[69] = t38;
  } else {
    t38 = $[69];
  }
  let t39;
  if ($[70] !== t33 || $[71] !== t38) {
    t39 = {
      title: t33,
      content: t38
    };
    $[70] = t33;
    $[71] = t38;
    $[72] = t39;
  } else {
    t39 = $[72];
  }
  let t40;
  if ($[73] !== t) {
    t40 = t("seoBuyOnInstallments:sections.5.title");
    $[73] = t;
    $[74] = t40;
  } else {
    t40 = $[74];
  }
  let t41;
  if ($[75] === Symbol.for("react.memo_cache_sentinel")) {
    t41 = {
      paragraph: <Paragraph />,
      semibold: <SemiBold />
    };
    $[75] = t41;
  } else {
    t41 = $[75];
  }
  let t42;
  if ($[76] !== t) {
    t42 = <Trans t={t} i18nKey="seoBuyOnInstallments:sections.5.content" components={t41} />;
    $[76] = t;
    $[77] = t42;
  } else {
    t42 = $[77];
  }
  let t43;
  if ($[78] !== t40 || $[79] !== t42) {
    t43 = {
      title: t40,
      content: t42
    };
    $[78] = t40;
    $[79] = t42;
    $[80] = t43;
  } else {
    t43 = $[80];
  }
  let t44;
  if ($[81] !== t) {
    t44 = t("seoBuyOnInstallments:sections.6.title");
    $[81] = t;
    $[82] = t44;
  } else {
    t44 = $[82];
  }
  let t45;
  if ($[83] === Symbol.for("react.memo_cache_sentinel")) {
    t45 = {
      paragraph: <Paragraph />,
      semibold: <SemiBold />
    };
    $[83] = t45;
  } else {
    t45 = $[83];
  }
  let t46;
  if ($[84] !== t) {
    t46 = <Trans t={t} i18nKey="seoBuyOnInstallments:sections.6.content" components={t45} />;
    $[84] = t;
    $[85] = t46;
  } else {
    t46 = $[85];
  }
  let t47;
  if ($[86] !== t) {
    t47 = t("seoBuyOnInstallments:sections.6.table.header.columns.1");
    $[86] = t;
    $[87] = t47;
  } else {
    t47 = $[87];
  }
  let t48;
  if ($[88] !== t47) {
    t48 = <th className="h-32 w-38 rounded-tr-none!">{t47}</th>;
    $[88] = t47;
    $[89] = t48;
  } else {
    t48 = $[89];
  }
  let t49;
  if ($[90] !== t) {
    t49 = t("seoBuyOnInstallments:sections.6.table.header.columns.2");
    $[90] = t;
    $[91] = t49;
  } else {
    t49 = $[91];
  }
  let t50;
  if ($[92] !== t49) {
    t50 = <th className="w-26 text-center!">{t49}</th>;
    $[92] = t49;
    $[93] = t50;
  } else {
    t50 = $[93];
  }
  let t51;
  if ($[94] !== t) {
    t51 = t("seoBuyOnInstallments:sections.6.table.header.columns.3");
    $[94] = t;
    $[95] = t51;
  } else {
    t51 = $[95];
  }
  let t52;
  if ($[96] !== t51) {
    t52 = <th className="w-26 text-center!">{t51}</th>;
    $[96] = t51;
    $[97] = t52;
  } else {
    t52 = $[97];
  }
  let t53;
  if ($[98] !== t) {
    t53 = t("seoBuyOnInstallments:sections.6.table.header.columns.4");
    $[98] = t;
    $[99] = t53;
  } else {
    t53 = $[99];
  }
  let t54;
  if ($[100] !== t53) {
    t54 = <th className="w-26 text-center!">{t53}</th>;
    $[100] = t53;
    $[101] = t54;
  } else {
    t54 = $[101];
  }
  let t55;
  if ($[102] !== t) {
    t55 = t("seoBuyOnInstallments:sections.6.table.header.columns.5");
    $[102] = t;
    $[103] = t55;
  } else {
    t55 = $[103];
  }
  let t56;
  if ($[104] !== t55) {
    t56 = <th className="w-26 text-center!">{t55}</th>;
    $[104] = t55;
    $[105] = t56;
  } else {
    t56 = $[105];
  }
  let t57;
  if ($[106] !== t) {
    t57 = t("seoBuyOnInstallments:sections.6.table.header.columns.6");
    $[106] = t;
    $[107] = t57;
  } else {
    t57 = $[107];
  }
  let t58;
  if ($[108] !== t57) {
    t58 = <th className="w-26 text-center!">{t57}</th>;
    $[108] = t57;
    $[109] = t58;
  } else {
    t58 = $[109];
  }
  let t59;
  if ($[110] !== t) {
    t59 = t("seoBuyOnInstallments:sections.6.table.header.columns.7");
    $[110] = t;
    $[111] = t59;
  } else {
    t59 = $[111];
  }
  let t60;
  if ($[112] !== t59) {
    t60 = <th className="w-26 rounded-tr-md text-center">{t59}</th>;
    $[112] = t59;
    $[113] = t60;
  } else {
    t60 = $[113];
  }
  let t61;
  if ($[114] !== t48 || $[115] !== t50 || $[116] !== t52 || $[117] !== t54 || $[118] !== t56 || $[119] !== t58 || $[120] !== t60) {
    t61 = <><tr>{t48}{t50}{t52}{t54}{t56}{t58}{t60}</tr></>;
    $[114] = t48;
    $[115] = t50;
    $[116] = t52;
    $[117] = t54;
    $[118] = t56;
    $[119] = t58;
    $[120] = t60;
    $[121] = t61;
  } else {
    t61 = $[121];
  }
  let t62;
  if ($[122] !== t) {
    t62 = t("seoBuyOnInstallments:sections.6.table.rows.1.columns.1");
    $[122] = t;
    $[123] = t62;
  } else {
    t62 = $[123];
  }
  let t63;
  if ($[124] !== t62) {
    t63 = <td className="w-38">{t62}</td>;
    $[124] = t62;
    $[125] = t63;
  } else {
    t63 = $[125];
  }
  let t64;
  if ($[126] !== t) {
    t64 = t("seoBuyOnInstallments:sections.6.table.rows.1.columns.2");
    $[126] = t;
    $[127] = t64;
  } else {
    t64 = $[127];
  }
  let t65;
  if ($[128] !== t64) {
    t65 = <td className="w-26">{t64}</td>;
    $[128] = t64;
    $[129] = t65;
  } else {
    t65 = $[129];
  }
  let t66;
  if ($[130] !== t) {
    t66 = t("seoBuyOnInstallments:sections.6.table.rows.1.columns.3");
    $[130] = t;
    $[131] = t66;
  } else {
    t66 = $[131];
  }
  let t67;
  if ($[132] !== t66) {
    t67 = <td className="w-26">{t66}</td>;
    $[132] = t66;
    $[133] = t67;
  } else {
    t67 = $[133];
  }
  let t68;
  if ($[134] !== t) {
    t68 = t("seoBuyOnInstallments:sections.6.table.rows.1.columns.4");
    $[134] = t;
    $[135] = t68;
  } else {
    t68 = $[135];
  }
  let t69;
  if ($[136] !== t68) {
    t69 = <td className="w-26">{t68}</td>;
    $[136] = t68;
    $[137] = t69;
  } else {
    t69 = $[137];
  }
  let t70;
  if ($[138] !== t) {
    t70 = t("seoBuyOnInstallments:sections.6.table.rows.1.columns.5");
    $[138] = t;
    $[139] = t70;
  } else {
    t70 = $[139];
  }
  let t71;
  if ($[140] !== t70) {
    t71 = <td className="w-26">{t70}</td>;
    $[140] = t70;
    $[141] = t71;
  } else {
    t71 = $[141];
  }
  let t72;
  if ($[142] !== t) {
    t72 = t("seoBuyOnInstallments:sections.6.table.rows.1.columns.6");
    $[142] = t;
    $[143] = t72;
  } else {
    t72 = $[143];
  }
  let t73;
  if ($[144] !== t72) {
    t73 = <td className="w-26">{t72}</td>;
    $[144] = t72;
    $[145] = t73;
  } else {
    t73 = $[145];
  }
  let t74;
  if ($[146] !== t) {
    t74 = t("seoBuyOnInstallments:sections.6.table.rows.1.columns.7");
    $[146] = t;
    $[147] = t74;
  } else {
    t74 = $[147];
  }
  let t75;
  if ($[148] !== t74) {
    t75 = <td className="w-26">{t74}</td>;
    $[148] = t74;
    $[149] = t75;
  } else {
    t75 = $[149];
  }
  let t76;
  if ($[150] !== t63 || $[151] !== t65 || $[152] !== t67 || $[153] !== t69 || $[154] !== t71 || $[155] !== t73 || $[156] !== t75) {
    t76 = <tr>{t63}{t65}{t67}{t69}{t71}{t73}{t75}</tr>;
    $[150] = t63;
    $[151] = t65;
    $[152] = t67;
    $[153] = t69;
    $[154] = t71;
    $[155] = t73;
    $[156] = t75;
    $[157] = t76;
  } else {
    t76 = $[157];
  }
  let t77;
  if ($[158] !== t) {
    t77 = t("seoBuyOnInstallments:sections.6.table.rows.2.columns.1");
    $[158] = t;
    $[159] = t77;
  } else {
    t77 = $[159];
  }
  let t78;
  if ($[160] !== t77) {
    t78 = <td className="w-38">{t77}</td>;
    $[160] = t77;
    $[161] = t78;
  } else {
    t78 = $[161];
  }
  let t79;
  if ($[162] !== t) {
    t79 = t("seoBuyOnInstallments:sections.6.table.rows.2.columns.2");
    $[162] = t;
    $[163] = t79;
  } else {
    t79 = $[163];
  }
  let t80;
  if ($[164] !== t79) {
    t80 = <td className="w-26">{t79}</td>;
    $[164] = t79;
    $[165] = t80;
  } else {
    t80 = $[165];
  }
  let t81;
  if ($[166] !== t) {
    t81 = t("seoBuyOnInstallments:sections.6.table.rows.2.columns.3");
    $[166] = t;
    $[167] = t81;
  } else {
    t81 = $[167];
  }
  let t82;
  if ($[168] !== t81) {
    t82 = <td className="w-26">{t81}</td>;
    $[168] = t81;
    $[169] = t82;
  } else {
    t82 = $[169];
  }
  let t83;
  if ($[170] !== t) {
    t83 = t("seoBuyOnInstallments:sections.6.table.rows.2.columns.4");
    $[170] = t;
    $[171] = t83;
  } else {
    t83 = $[171];
  }
  let t84;
  if ($[172] !== t83) {
    t84 = <td className="w-26">{t83}</td>;
    $[172] = t83;
    $[173] = t84;
  } else {
    t84 = $[173];
  }
  let t85;
  if ($[174] !== t) {
    t85 = t("seoBuyOnInstallments:sections.6.table.rows.2.columns.5");
    $[174] = t;
    $[175] = t85;
  } else {
    t85 = $[175];
  }
  let t86;
  if ($[176] !== t85) {
    t86 = <td className="w-26">{t85}</td>;
    $[176] = t85;
    $[177] = t86;
  } else {
    t86 = $[177];
  }
  let t87;
  if ($[178] !== t) {
    t87 = t("seoBuyOnInstallments:sections.6.table.rows.2.columns.6");
    $[178] = t;
    $[179] = t87;
  } else {
    t87 = $[179];
  }
  let t88;
  if ($[180] !== t87) {
    t88 = <td className="w-26">{t87}</td>;
    $[180] = t87;
    $[181] = t88;
  } else {
    t88 = $[181];
  }
  let t89;
  if ($[182] !== t) {
    t89 = t("seoBuyOnInstallments:sections.6.table.rows.2.columns.7");
    $[182] = t;
    $[183] = t89;
  } else {
    t89 = $[183];
  }
  let t90;
  if ($[184] !== t89) {
    t90 = <td className="w-26">{t89}</td>;
    $[184] = t89;
    $[185] = t90;
  } else {
    t90 = $[185];
  }
  let t91;
  if ($[186] !== t78 || $[187] !== t80 || $[188] !== t82 || $[189] !== t84 || $[190] !== t86 || $[191] !== t88 || $[192] !== t90) {
    t91 = <tr>{t78}{t80}{t82}{t84}{t86}{t88}{t90}</tr>;
    $[186] = t78;
    $[187] = t80;
    $[188] = t82;
    $[189] = t84;
    $[190] = t86;
    $[191] = t88;
    $[192] = t90;
    $[193] = t91;
  } else {
    t91 = $[193];
  }
  let t92;
  if ($[194] !== t) {
    t92 = t("seoBuyOnInstallments:sections.6.table.rows.3.columns.1");
    $[194] = t;
    $[195] = t92;
  } else {
    t92 = $[195];
  }
  let t93;
  if ($[196] !== t92) {
    t93 = <td className="w-38">{t92}</td>;
    $[196] = t92;
    $[197] = t93;
  } else {
    t93 = $[197];
  }
  let t94;
  if ($[198] !== t) {
    t94 = t("seoBuyOnInstallments:sections.6.table.rows.3.columns.2");
    $[198] = t;
    $[199] = t94;
  } else {
    t94 = $[199];
  }
  let t95;
  if ($[200] !== t94) {
    t95 = <td className="w-26">{t94}</td>;
    $[200] = t94;
    $[201] = t95;
  } else {
    t95 = $[201];
  }
  let t96;
  if ($[202] !== t) {
    t96 = t("seoBuyOnInstallments:sections.6.table.rows.3.columns.3");
    $[202] = t;
    $[203] = t96;
  } else {
    t96 = $[203];
  }
  let t97;
  if ($[204] !== t96) {
    t97 = <td className="w-26">{t96}</td>;
    $[204] = t96;
    $[205] = t97;
  } else {
    t97 = $[205];
  }
  let t98;
  if ($[206] !== t) {
    t98 = t("seoBuyOnInstallments:sections.6.table.rows.3.columns.4");
    $[206] = t;
    $[207] = t98;
  } else {
    t98 = $[207];
  }
  let t99;
  if ($[208] !== t98) {
    t99 = <td className="w-26">{t98}</td>;
    $[208] = t98;
    $[209] = t99;
  } else {
    t99 = $[209];
  }
  let t100;
  if ($[210] !== t) {
    t100 = t("seoBuyOnInstallments:sections.6.table.rows.3.columns.5");
    $[210] = t;
    $[211] = t100;
  } else {
    t100 = $[211];
  }
  let t101;
  if ($[212] !== t100) {
    t101 = <td className="w-26">{t100}</td>;
    $[212] = t100;
    $[213] = t101;
  } else {
    t101 = $[213];
  }
  let t102;
  if ($[214] !== t) {
    t102 = t("seoBuyOnInstallments:sections.6.table.rows.3.columns.6");
    $[214] = t;
    $[215] = t102;
  } else {
    t102 = $[215];
  }
  let t103;
  if ($[216] !== t102) {
    t103 = <td className="w-26">{t102}</td>;
    $[216] = t102;
    $[217] = t103;
  } else {
    t103 = $[217];
  }
  let t104;
  if ($[218] !== t) {
    t104 = t("seoBuyOnInstallments:sections.6.table.rows.3.columns.7");
    $[218] = t;
    $[219] = t104;
  } else {
    t104 = $[219];
  }
  let t105;
  if ($[220] !== t104) {
    t105 = <td className="w-26">{t104}</td>;
    $[220] = t104;
    $[221] = t105;
  } else {
    t105 = $[221];
  }
  let t106;
  if ($[222] !== t101 || $[223] !== t103 || $[224] !== t105 || $[225] !== t93 || $[226] !== t95 || $[227] !== t97 || $[228] !== t99) {
    t106 = <tr>{t93}{t95}{t97}{t99}{t101}{t103}{t105}</tr>;
    $[222] = t101;
    $[223] = t103;
    $[224] = t105;
    $[225] = t93;
    $[226] = t95;
    $[227] = t97;
    $[228] = t99;
    $[229] = t106;
  } else {
    t106 = $[229];
  }
  let t107;
  if ($[230] !== t) {
    t107 = t("seoBuyOnInstallments:sections.6.table.rows.4.columns.1");
    $[230] = t;
    $[231] = t107;
  } else {
    t107 = $[231];
  }
  let t108;
  if ($[232] !== t107) {
    t108 = <td className="w-38">{t107}</td>;
    $[232] = t107;
    $[233] = t108;
  } else {
    t108 = $[233];
  }
  let t109;
  if ($[234] !== t) {
    t109 = t("seoBuyOnInstallments:sections.6.table.rows.4.columns.2");
    $[234] = t;
    $[235] = t109;
  } else {
    t109 = $[235];
  }
  let t110;
  if ($[236] !== t109) {
    t110 = <td className="w-26">{t109}</td>;
    $[236] = t109;
    $[237] = t110;
  } else {
    t110 = $[237];
  }
  let t111;
  if ($[238] !== t) {
    t111 = t("seoBuyOnInstallments:sections.6.table.rows.4.columns.3");
    $[238] = t;
    $[239] = t111;
  } else {
    t111 = $[239];
  }
  let t112;
  if ($[240] !== t111) {
    t112 = <td className="w-26">{t111}</td>;
    $[240] = t111;
    $[241] = t112;
  } else {
    t112 = $[241];
  }
  let t113;
  if ($[242] !== t) {
    t113 = t("seoBuyOnInstallments:sections.6.table.rows.4.columns.4");
    $[242] = t;
    $[243] = t113;
  } else {
    t113 = $[243];
  }
  let t114;
  if ($[244] !== t113) {
    t114 = <td className="w-26">{t113}</td>;
    $[244] = t113;
    $[245] = t114;
  } else {
    t114 = $[245];
  }
  let t115;
  if ($[246] !== t) {
    t115 = t("seoBuyOnInstallments:sections.6.table.rows.4.columns.5");
    $[246] = t;
    $[247] = t115;
  } else {
    t115 = $[247];
  }
  let t116;
  if ($[248] !== t115) {
    t116 = <td className="w-26">{t115}</td>;
    $[248] = t115;
    $[249] = t116;
  } else {
    t116 = $[249];
  }
  let t117;
  if ($[250] !== t) {
    t117 = t("seoBuyOnInstallments:sections.6.table.rows.4.columns.6");
    $[250] = t;
    $[251] = t117;
  } else {
    t117 = $[251];
  }
  let t118;
  if ($[252] !== t117) {
    t118 = <td className="w-26">{t117}</td>;
    $[252] = t117;
    $[253] = t118;
  } else {
    t118 = $[253];
  }
  let t119;
  if ($[254] !== t) {
    t119 = t("seoBuyOnInstallments:sections.6.table.rows.4.columns.7");
    $[254] = t;
    $[255] = t119;
  } else {
    t119 = $[255];
  }
  let t120;
  if ($[256] !== t119) {
    t120 = <td className="w-26">{t119}</td>;
    $[256] = t119;
    $[257] = t120;
  } else {
    t120 = $[257];
  }
  let t121;
  if ($[258] !== t108 || $[259] !== t110 || $[260] !== t112 || $[261] !== t114 || $[262] !== t116 || $[263] !== t118 || $[264] !== t120) {
    t121 = <tr>{t108}{t110}{t112}{t114}{t116}{t118}{t120}</tr>;
    $[258] = t108;
    $[259] = t110;
    $[260] = t112;
    $[261] = t114;
    $[262] = t116;
    $[263] = t118;
    $[264] = t120;
    $[265] = t121;
  } else {
    t121 = $[265];
  }
  let t122;
  if ($[266] !== t106 || $[267] !== t121 || $[268] !== t76 || $[269] !== t91) {
    t122 = <>{t76}{t91}{t106}{t121}</>;
    $[266] = t106;
    $[267] = t121;
    $[268] = t76;
    $[269] = t91;
    $[270] = t122;
  } else {
    t122 = $[270];
  }
  let t123;
  if ($[271] !== t122 || $[272] !== t61) {
    t123 = <Table head={t61} body={t122} className="mt-8 mb-8" />;
    $[271] = t122;
    $[272] = t61;
    $[273] = t123;
  } else {
    t123 = $[273];
  }
  let t124;
  let t125;
  if ($[274] === Symbol.for("react.memo_cache_sentinel")) {
    t124 = <Paragraph />;
    t125 = <SemiBold />;
    $[274] = t124;
    $[275] = t125;
  } else {
    t124 = $[274];
    t125 = $[275];
  }
  let t126;
  if ($[276] === Symbol.for("react.memo_cache_sentinel")) {
    t126 = <Link analyticsParam="linkPayInThree" testId="linkPayInThree" to={LINKS().payInThree} />;
    $[276] = t126;
  } else {
    t126 = $[276];
  }
  let t127;
  if ($[277] === Symbol.for("react.memo_cache_sentinel")) {
    t127 = {
      paragraph: t124,
      semibold: t125,
      link1: t126,
      link2: <Link analyticsParam="linkWhereToShop" testId="linkWhereToShop" to={LINKS().whereToShop} />
    };
    $[277] = t127;
  } else {
    t127 = $[277];
  }
  let t128;
  if ($[278] !== t) {
    t128 = <Trans t={t} i18nKey="seoBuyOnInstallments:sections.6.content2" components={t127} />;
    $[278] = t;
    $[279] = t128;
  } else {
    t128 = $[279];
  }
  let t129;
  if ($[280] !== t123 || $[281] !== t128 || $[282] !== t46) {
    t129 = <>{t46}{t123}{t128}</>;
    $[280] = t123;
    $[281] = t128;
    $[282] = t46;
    $[283] = t129;
  } else {
    t129 = $[283];
  }
  let t130;
  if ($[284] !== t129 || $[285] !== t44) {
    t130 = {
      title: t44,
      content: t129
    };
    $[284] = t129;
    $[285] = t44;
    $[286] = t130;
  } else {
    t130 = $[286];
  }
  let t131;
  if ($[287] !== t) {
    t131 = t("core:faqs.title");
    $[287] = t;
    $[288] = t131;
  } else {
    t131 = $[288];
  }
  let t132;
  if ($[289] !== faqsData) {
    t132 = <FAQs data={faqsData} />;
    $[289] = faqsData;
    $[290] = t132;
  } else {
    t132 = $[290];
  }
  let t133;
  if ($[291] !== t131 || $[292] !== t132) {
    t133 = {
      title: t131,
      content: t132
    };
    $[291] = t131;
    $[292] = t132;
    $[293] = t133;
  } else {
    t133 = $[293];
  }
  let t134;
  if ($[294] !== t130 || $[295] !== t133 || $[296] !== t21 || $[297] !== t25 || $[298] !== t32 || $[299] !== t39 || $[300] !== t43) {
    t134 = [t21, t25, t32, t39, t43, t130, t133];
    $[294] = t130;
    $[295] = t133;
    $[296] = t21;
    $[297] = t25;
    $[298] = t32;
    $[299] = t39;
    $[300] = t43;
    $[301] = t134;
  } else {
    t134 = $[301];
  }
  let t135;
  if ($[302] !== menuPromoBanners || $[303] !== t12 || $[304] !== t134 || $[305] !== t5 || $[306] !== t7 || $[307] !== t9) {
    t135 = <SeoPageLayout menuPromoBanners={menuPromoBanners} seo={t5} title={t7} intro={t9} introButton={t12} sections={t134} />;
    $[302] = menuPromoBanners;
    $[303] = t12;
    $[304] = t134;
    $[305] = t5;
    $[306] = t7;
    $[307] = t9;
    $[308] = t135;
  } else {
    t135 = $[308];
  }
  return t135;
}
export const getStaticProps: GetStaticProps = async ctx => {
  const isAllowed = isAllowedRoute('nakup-na-splatky');
  if (!isAllowed) {
    return {
      notFound: true
    };
  }
  return {
    props: {
      menuPromoBanners: await getAllPageMenuPromoBanners(),
      ...(await getIntlProps(ctx, ['core', 'seoBuyOnInstallments']))
    }
  };
};